import styles from '../CaseBuilderEnhanced.module.css';

function buildConicGradient(segments) {
    const total = (segments || []).reduce((sum, seg) => sum + (Number(seg.value) || 0), 0);
    if (!total) return 'conic-gradient(#eaeef2 0 100%)';
    let acc = 0;
    const parts = [];
    for (const seg of segments) {
        const value = Number(seg.value) || 0;
        if (value <= 0) continue;
        const start = (acc / total) * 100;
        acc += value;
        const end = (acc / total) * 100;
        parts.push(`${seg.color} ${start}% ${end}%`);
    }
    if (!parts.length) return 'conic-gradient(#eaeef2 0 100%)';
    return `conic-gradient(${parts.join(', ')})`;
}

/**
 * Progress ring. Pass `percent` for a single-color fill, or `segments`
 * ([{ value, color }]) for a multi-status conic chart.
 */
export default function CompletenessMeter({
    percent,
    segments = null,
    centerLabel = null,
    label,
    sublabel,
    ariaLabel = null,
}) {
    const useSegments = Array.isArray(segments) && segments.length > 0;
    const pct = Math.min(100, Math.max(0, percent ?? 0));
    const background = useSegments
        ? buildConicGradient(segments)
        : undefined;
    const ringStyle = useSegments
        ? { background }
        : { '--pct': `${pct}%` };
    const inner = centerLabel != null
        ? centerLabel
        : (useSegments ? null : `${pct}%`);
    const defaultAria = useSegments
        ? (ariaLabel || label || 'Status breakdown')
        : (ariaLabel || `${pct}% complete`);

    return (
        <div className={styles.meterWrap}>
            <div
                className={`${styles.meterRing} ${useSegments ? styles.meterRingSegments : ''}`}
                style={ringStyle}
                aria-label={defaultAria}
            >
                <div className={styles.meterRingInner}>{inner}</div>
            </div>
            <div className={styles.meterText}>
                {label && <div className={styles.statLabel}>{label}</div>}
                {sublabel && <div className={styles.slideCardMeta}>{sublabel}</div>}
            </div>
        </div>
    );
}
